import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  asfTransactionsListAsync,
  selectAsfTransactionsListStatus,
} from "../transactionsSlice";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { selectCompany } from "../../homeSlice";

import { SharedInterfaceBadgeTransactions } from "./sharedInterface";

export const BadgeTransactionsTab = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const company = useAppSelector(selectCompany);
  const asfTransactionsListStatus = useAppSelector(
    selectAsfTransactionsListStatus,
  );

  useEffect(() => {
    if (company && asfTransactionsListStatus === "idle") {
      void dispatch(asfTransactionsListAsync(company.uuid));
    }
  }, [dispatch, company, asfTransactionsListStatus]);

  if (params.tab !== "badges") {
    return;
  }
  return <SharedInterfaceBadgeTransactions />;
};
